import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {SnackbarState} from '@local/redux/state/snackbar';

const initialState: SnackbarState = {
  message: '',
  open: false,
  severity: 'info',
};
const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    error: (state, action: PayloadAction<{message: string; duration?: EpochMillis}>) => {
      return {
        open: true,
        severity: 'error',
        ...action.payload,
      };
    },
    warning: (state, action: PayloadAction<{message: string; duration?: EpochMillis}>) => {
      return {
        open: true,
        severity: 'warning',
        ...action.payload,
      };
    },
    success: (state, action: PayloadAction<{message: string; duration?: EpochMillis}>) => {
      return {
        open: true,
        severity: 'success',
        ...action.payload,
      };
    },
    info: (state, action: PayloadAction<{message: string; duration?: EpochMillis}>) => {
      return {
        open: true,
        severity: 'info',
        ...action.payload,
      };
    },
    close: state => {
      return {
        ...state,
        open: false,
      };
    },
    clear: () => initialState,
  },
});
export const snackbarReducer = snackbarSlice.reducer;
export const snackbarActions = snackbarSlice.actions;
